import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useRecoilState } from "recoil";
import pathState from "../../../atoms/pathstate";
import getExpressHeaders from "../../../CommonFunction/getExpressHeaders";
import { ProcessDataForExpress } from "../../../CommonFunction/ProcessDataForExpress";
import { getFields } from "../../../Utils/AllPagesQuriesAndMutations";
import { LoadTable, Loading } from "../../Components";
import HeaderDiv from "../../Components/HeaderDiv/HeaderDiv";
import { useModalContext } from "../../Components/Reactportal/ModalContext";
import { ErrorToast } from "../../Components/ToastComponent/RectHotToast";
import useLazyFetch from "../EmtAccounts/UseLazyFetch";
import { useLazyQuery } from "@apollo/client";

const VendorAccount = () => {
  let Refetch = useSelector((store) => store?.FormFieldData.refresh);
  const dispatch = useDispatch();
  const { pushKey, popKey, getTopKey } = useModalContext();
  const [{ currentPath, previousPath, PerviousTitle, CurrentTitle }, setPaths] = useRecoilState(pathState);
  const Key = "Vendor_Account";
  const [fieldsToShowInTableHeadersData, setFieldsToShowInTableHeadersData] = useState([]);

  const [getCurrentField, { data: TableHeaders }] = useLazyQuery(getFields, {
    fetchPolicy: "network-only",
  });
  const { data, loading, error, fetchData } = useLazyFetch(
    `${process.env.REACT_APP_API_URL}/api/accounts/searchByAccountType`,
    getExpressHeaders()
  );

  useEffect(() => {
    getCurrentField({
      variables: { Table_Key: Key },
    }).then((res) => {
      const fieldsData = res?.data?.GetUserTableColumnManagementWithUserId_Page_ID?.filter((item) => item.Status).map(
        (item) => [item?.Field_Name, item?.Table_Column_Name, item?.Column_Total ? item?.Field_Name : null]
      );
      const Headers = res?.data?.GetUserTableColumnManagementWithUserId_Page_ID?.filter((item) => item.Status).map(
        (item) => item?.Field_Name
      );
      console.log(fieldsData, "HeadersVendor");
      setFieldsToShowInTableHeadersData(fieldsData);
      fetchData({
        Account_Type: ["Vendor Account"],
        Table_Key: Key,
        TableHeaders: JSON.stringify(Headers),
      });
    });

    if (Refetch) {
      dispatch({ type: "Refetch", payload: false });
    }
  }, [Refetch]);

  const config = useMemo(
    () => ({
      dataKey: "data",
      dateKeysWithoutTime: ["KYC_Complete_Time"],
      dateKeys: ["createdAt", "updatedAt"],
      deleteKeys: ["is_Audit", "__typename"],
    }),
    []
  );

  useEffect(() => {
    console.log(currentPath, previousPath, "vvvvvvvv");
    if (currentPath !== previousPath) {
      console.log(Key, "KeyKeyKeyKgv ey");
      popKey();
      pushKey(Key);
      setPaths((prev) => ({ ...prev, CurrentTitle: Key }));
    }
  }, [currentPath, previousPath]);

  useEffect(() => {
    if (error) ErrorToast(error.message);
  }, [error]);

  const formData = useMemo(() => {
    return loading || !data ? [] : ProcessDataForExpress(data, config);
  }, [loading, data]);

  return (
    <div>
      <HeaderDiv title={"Vendor Account Data"} TableKey={Key} MoreActions={{ Is_Merge: true }} />
      {loading ? (
        <Loading />
      ) : !loading && (!formData || formData.length === 0) ? (
        <p className="DataNotAvailable">Data not Available</p>
      ) : (
        <LoadTable
          title="Vendor_Account"
          data={formData}
          loading={loading}
          error={error}
          TableHeaders={fieldsToShowInTableHeadersData}
        />
      )}
    </div>
  );
};

export default VendorAccount;
